import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import ProductCreatedModal from "./modals/ProductCreatedModal";

export default function CreateProduct() {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [recurring, setRecurring] = useState(null);
  const [price, setPrice] = useState("");
  const [interval, setInterval] = useState("month");
  const { id } = useParams();
  const { user, dispatch } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [totalAccess, setTotalAccess] = useState(false);
  const [token, setToken] = useState(0);
  const [productCreatedModal, setProductCreatedModal] = useState(false);
  const [serverError, setServerError] = useState("");
  const navi = useNavigate();
  const [routineClasses, setRoutineClasses] = useState([]);
  const [oneOffClasses, setOneOffClasses] = useState([]);
  const [futureClasses, setFutureClasses] = useState([]);
  const [today, setToday] = useState(new Date());

  const [selectedClasses, setSelectedClasses] = useState([]);

  //errors
  const [priceErr, setPriceErr] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [descriptionErr, setDescriptionErr] = useState("");

  const handlePriceChange = (e) => {
    // Remove all non-numeric characters except for the decimal point
    let inputValue = e.target.value.replace(/[^\d.]/g, "");

    // Ensure there is only one decimal point and restrict to two decimal places
    const decimalIndex = inputValue.indexOf(".");
    if (decimalIndex !== -1) {
      inputValue =
        inputValue.substring(0, decimalIndex + 1) +
        inputValue.substring(decimalIndex + 1).replace(".", "");
      inputValue = inputValue.substring(0, decimalIndex + 3);
    }

    setPrice(inputValue);
  };

  const handleTotalAccessCheckboxChange = (event) => {
    setTotalAccess(event.target.checked);
  };

  const handleCheckboxChange = (classId) => {
    const isSelected = selectedClasses.some((item) => item.eventId === classId);

    if (isSelected) {
      setSelectedClasses(
        selectedClasses.filter((item) => item.eventId !== classId)
      );
    } else {
      setSelectedClasses([
        ...selectedClasses,
        { productId: id, eventId: classId },
      ]);
    }
  };

  useEffect(() => {
    const future = oneOffClasses.filter(
      (cls) => new Date(cls.oneOffDate) >= today
    );

    setFutureClasses(future);
  }, [oneOffClasses, user]);

  const fetchData = async () => {
    try {
      // Fetch routine classes
      const routineResponse = await axios.get(
        `${ApiConnectionString}/api/RoutineEventsByClub/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (routineResponse.status === 200) {
        setRoutineClasses(routineResponse.data);
      }

      // Fetch one-off classes
      const oneOffResponse = await axios.get(
        `${ApiConnectionString}/api/OneoffEventsByClub/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (oneOffResponse.status === 200) {
        setOneOffClasses(oneOffResponse.data);
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching data:", error);
      // Handle errors if needed
    }
  };
  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [id, user.token]); // Include dependencies if needed

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let error = false;

    const formatString = (input) => {
      if (typeof input === "string" && !input.includes(".")) {
        return input + "00";
      }
      return input;
    };

    const formattedPrice = formatString(price);

    if (parseInt(formattedPrice.toString().replace(".", ""), 10) < 100) {
      setPriceErr("too low");
      error = true;
    }
    if (name.toUpperCase() === "PREMIUM MEMBOTIC CLUB") {
      setNameErr("The name is not available");
      error = true;
    }

    if (recurring) {
      if (recurring) {
        switch (interval) {
          case "month":
            if (price > 250) {
              setPriceErr("Monthly subscriptions must not exceed £250");
              error = true;
            }
            break;
          case "week":
            if (price > 75) {
              setPriceErr("Weekly subscriptions must not exceed £75");
              error = true;
            }
            break;
          case "year":
            if (price > 2500) {
              setPriceErr("Yearly subscriptions must not exceed £2500");
              error = true;
            }
            break;
          default:
            // Handle unexpected values
            break;
        }
      }
    } else {
      if (price > 250) {
        setPriceErr("Price must not exceed £250");
        error = true;
      }
    }

    if (!error) {
      const clubId = id;
      let createProduct = {};

      if (!recurring) {
        createProduct = {
          name,
          description,
          recurring,
          price: parseInt(formattedPrice.toString().replace(".", ""), 10),
          clubId,
          token,
          accesses: totalAccess ? null : selectedClasses,
          totalAccess,
        };
      } else {
        createProduct = {
          name,
          description,
          recurring,
          price: parseInt(formattedPrice.toString().replace(".", ""), 10),
          clubId,
          interval,
          accesses: totalAccess ? null : selectedClasses,
          totalAccess,
        };
      }

      try {
        const response = await axios.post(
          `${ApiConnectionString}/api/product`,
          createProduct,
          {
            headers: { Authorization: `bearer ${user.token}` },
          }
        );

        if (response.status === 200) {
          setProductCreatedModal(true);
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          setServerError(error.response.data);
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    if (recurring == null) {
      return (
        <div className="container bg-white rounded-3 shadow-sm p-3 p-md-4 mb-5">
           <button
            className="btn btn-outline-secondary"
            onClick={() => navi(`/myoneclub/${id}`)}
          >
            ← Back
          </button>
          <div className="d-flex align-items-center justify-content-between mb-2">
            <p className="fw-bold h4 mb-0">Create A Payment Option</p>
          </div>

          <p className="text-muted mb-4">
            Please select from either Flexible Class Pack or Subscription.
          </p>

          <div className="row g-4">
            <div className="col-md-6">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body d-flex flex-column">
                  <h5 className="mb-2">Flexible Class Pack</h5>
                  <p className="text-muted mb-4">
                    This option allows members to purchase a bulk of classes up
                    front, and then book into them as and when they want using a
                    token system. Each class booking will deduct a token from
                    their balance. Ideal for those who want flexibility without
                    a regular commitment.
                  </p>
                  <button
                    className="btn btn-primary mt-auto"
                    onClick={() => setRecurring(false)}
                  >
                    Flexible Class Pack
                  </button>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body d-flex flex-column">
                  <h5 className="mb-2">Subscription</h5>
                  <p className="text-muted mb-4">
                    This option provides access to classes on a recurring basis,
                    typically through a weekly or monthly payment. Best for
                    members who attend regularly and want to save money compared
                    to individual payments.
                  </p>
                  <button
                    className="btn btn-primary mt-auto"
                    onClick={() => setRecurring(true)}
                  >
                    Subscription
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="container bg-white rounded-3 shadow-sm p-3 p-md-4 mt-3 mb-5">
        <div className="d-flex align-items-center justify-content-between">
          <p className="fw-bold h4 mb-0">Create A Payment Option</p>
          <button
            className="btn btn-outline-secondary"
            onClick={() => setRecurring(null)}
          >
            ← Back
          </button>
        </div>

        <form className="my-3">
          <div className="row g-3 col-md-8 mx-auto">
            <div className="col-12 text-center">
              {recurring ? (
                <p className="blueText fontSize18 fw-bold mb-0">Subscription</p>
              ) : (
                <p className="blueText fontSize18 fw-bold mb-0">
                  Flexible Class Pack
                </p>
              )}
            </div>

            <div className="col-12">
              <label className="form-label m-0">Title</label>
              <input
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              {nameErr && (
                <div className="text-danger small mt-1">{nameErr}</div>
              )}
            </div>

            <div className="col-12">
              <label className="form-label m-0">Subtitle</label>
              <input
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
              <div className="form-text">
                For example, Access to all classes or Access to all beginner
                classes.
              </div>
            </div>

            <div className="col-12">
              <label className="form-label m-0">Cost</label>
              <input
                type="text"
                className="form-control"
                value={`£${price}`}
                onChange={handlePriceChange}
                required
              />
              {priceErr && (
                <div className="text-danger small mt-1">{priceErr}</div>
              )}
            </div>

            {!recurring && (
              <div className="col-12">
                <label className="form-label m-0">Classes</label>
                <input
                  className="form-control"
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                />
                <div className="form-text">
                  This indicates how many class tokens this is worth. For
                  example, entering 10 means a user can book into 10 classes
                  with this token.
                </div>
              </div>
            )}

            {recurring && (
              <div className="col-12">
                <label className="form-label m-0">Select Interval</label>
                <select
                  id="interval"
                  name="interval"
                  className="form-select"
                  value={interval}
                  onChange={(e) => setInterval(e.target.value)}
                >
                  <option value="month">Month</option>
                  <option value="week">Week</option>
                  <option value="year">Year</option>
                </select>
              </div>
            )}
          </div>

          {serverError && (
            <div className="text-danger text-center mt-2">{serverError}</div>
          )}
        </form>

        <div className="col-md-8 mx-auto">
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={totalAccess}
              onChange={handleTotalAccessCheckboxChange}
              id="totalAccess"
            />
            <label className="form-check-label" htmlFor="totalAccess">
              Total Access
            </label>
          </div>

          {!totalAccess && (
            <div>
              <p className="text-muted">
                If this payment option grants access to all classes at your
                club, tick Total Access above. Otherwise, select from the
                classes below to grant access.
              </p>

              {routineClasses.length != 0 && (
                <>
                  <div className="lightBlueBanner">
                    <p className="fw-bold p-1 mb-0">Routine Classes</p>
                  </div>
                  <p className="mt-2">
                    Tick the classes that are granted access with this payment
                    option.
                  </p>

                  <form>
                    {routineClasses.map((cls) => (
                      <div className="form-check" key={cls.id}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={cls.id}
                          checked={selectedClasses.some(
                            (item) => item.eventId === cls.id
                          )}
                          onChange={() => handleCheckboxChange(cls.id)}
                          id={`routine-${cls.id}`}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`routine-${cls.id}`}
                        >
                          {cls.name} | {cls.day} | {cls.timeIn}-{cls.timeOut}
                        </label>
                      </div>
                    ))}
                  </form>
                </>
              )}

              {futureClasses.length != 0 && (
                <>
                  <div className="lightBlueBanner mt-3">
                    <p className="fw-bold p-1 mb-0">One Off Classes</p>
                  </div>
                  <p className="mt-2">
                    Tick the classes that are granted access with this payment
                    option.
                  </p>

                  <form>
                    {futureClasses.map((cls) => (
                      <div className="form-check" key={cls.id}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={cls.id}
                          checked={selectedClasses.some(
                            (item) => item.eventId === cls.id
                          )}
                          onChange={() => handleCheckboxChange(cls.id)}
                          id={`future-${cls.id}`}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`future-${cls.id}`}
                        >
                          {cls.name} | {cls.day} | {cls.timeIn}-{cls.timeOut}
                        </label>
                      </div>
                    ))}
                  </form>
                </>
              )}
            </div>
          )}
        </div>

        <div className="d-flex justify-content-center mt-4">
          <button className="saveChanges-button" onClick={handleSubmit}>
            Create
          </button>
        </div>

        <hr className="my-5" />

        {recurring ? (
          <div className="text-center">
            <p>
              If you would like to switch to a Flexible Class Pack option, press
              the button below.
            </p>
            <button
              className="saveChanges-button"
              onClick={() => setRecurring(false)}
            >
              Switch To Flexible Class Pack
            </button>
          </div>
        ) : (
          <div className="text-center">
            <p>
              If you would like to switch to a Subscription option, press the
              button below.
            </p>
            <button
              className="saveChanges-button"
              onClick={() => setRecurring(true)}
            >
              Switch To Subscription
            </button>
          </div>
        )}

        {productCreatedModal && <ProductCreatedModal id={id} />}
      </div>
    );
  }
}
